import { ApiService } from './index'
import { ApiResponse } from '@types'

export type NotificationType = 'alert' | 'device' | 'inspection' | 'group' | 'system'
export type NotificationSeverity = 'info' | 'low' | 'medium' | 'high' | 'critical'

export interface AppNotification {
  id: number
  notification_type: NotificationType
  severity: NotificationSeverity
  title: string
  message: string
  action_url: string
  alert: number | null
  is_read: boolean
  read_at: string | null
  created_at: string
}

export const notificationsApi = {
  // Paginated list of the current user's notifications
  getNotifications: (params?: { is_read?: boolean; page?: number; page_size?: number }) =>
    ApiService.get<ApiResponse<AppNotification[]>>('notifications/', { params }),

  getUnreadCount: () =>
    ApiService.get<ApiResponse<{ unread_count: number }>>('notifications/unread_count/'),

  markRead: (id: number) =>
    ApiService.post<ApiResponse<AppNotification>>(`notifications/${id}/mark_read/`),

  markAllRead: () =>
    ApiService.post<ApiResponse<{ updated: number }>>('notifications/mark_all_read/'),
}
